import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { PaymentInputFieldWUT } from '../../../ui/payment-input-field';
export const PaymentInputWUT = props => {
  const {
    fieldType = FIELD_TYPES.PAYMENT_INPUT
  } = props;
  return /*#__PURE__*/React.createElement(PaymentInputFieldWUT, _extends({}, props, {
    fieldType: fieldType
  }));
};
//# sourceMappingURL=payment-input-wut.js.map